import { render, staticRenderFns } from "./Crawlers.vue?vue&type=template&id=7f748904&"
import script from "./Crawlers.vue?vue&type=script&lang=js&"
export * from "./Crawlers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports